import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  allRoles: [],
  role: [],
  rolesBySite: [],
  rolesByCustomerID: [],
  createdRole: null,
  updatedRole: null, // { index: index of role in roles table, updatedRole: updated role data }
  deletedRole: null, // Index of deleted role in roles table
  isLoading: false,
  error: [],
};

const roleSlice = createSlice({
  name: 'role',
  initialState,
  reducers: {
    setReducerError: (state, action) => {
      state.error = action.payload;
    },
    setAllRoles: (state, action) => {
      state.allRoles = action.payload;
      state.error = [];
    },
    setRole: (state, action) => {
      state.role = action.payload;
      state.error = [];
    },
    setRolesBySite: (state, action) => {
      state.rolesBySite = action.payload;
      state.error = [];
    },
    setRolesByCustomerID: (state, action) => {
      state.rolesByCustomerID = action.payload;
      state.error = [];
    },
    setCreatedRole: (state, action) => {
      state.createdRole = action.payload;
      state.error = [];
    },
    setUpdatedRole: (state, action) => {
      state.updatedRole = action.payload;
      state.error = [];
    },
    setDeletedRole: (state, action) => {
      state.deletedRole = action.payload;
      state.error = [];
    },
    setResetRole: () => {
      return initialState;
    },
  },
});

export const {
  setReducerError,
  setAllRoles,
  setRole,
  setRolesBySite,
  setRolesByCustomerID,
  setCreatedRole,
  setUpdatedRole,
  setDeletedRole,
  setResetRole,
} = roleSlice.actions;

export default roleSlice.reducer;
